import React from "react";
import { Field, FieldArray, ErrorMessage } from "formik";

export default function SchoolEngagementsComponent() {
  return (
    <div
      className="col-12 my-0 rounded-3 p-4"
      style={{
        border: "1px solid #e9ecef",
        backgroundColor: "#fff",
      }}
    >
      <h4 className="fw-bold mb-4">School Leadership and Activities</h4>
      <div className="alert alert-info">
        <p className="mb-0">
          Add details of your school leadership roles, sports, and other
          extracurricular activities.
        </p>
        <em>Example:</em>
        <ul className="mb-0">
          <li>2016 - 2017 Head Prefect</li>
          <li>2015 - 2016 Under 15 Cricket Captain</li>
          <li>2014 - 2015 Secretary of Science Society</li>
          <li>2014 - 2015 Member of Media Club</li>
          <li>2013 - 2014 Scout</li>
        </ul>
        <p className="mt-2">
          Press <strong>"Add Another"</strong> button to add records.
        </p>
      </div>

      <FieldArray name="studentEngagements">
        {({ push, remove, form }) => {
          const { values } = form;
          const engagements = values.studentEngagements || [];

          return (
            <>
              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Start Year</th>
                    <th>End Year</th>
                    <th>Designation</th>
                    <th style={{ width: "80px" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {engagements.map((row, index) => (
                    <tr key={index}>
                      <td>
                        <Field
                          type="number"
                          name={`studentEngagements[${index}].startYear`}
                          className="form-control"
                          placeholder="Ex: 2016"
                          required
                        />
                        <ErrorMessage
                          name={`studentEngagements[${index}].startYear`}
                          component="div"
                          className="text-danger"
                        />
                      </td>
                      <td>
                        <Field
                          type="number"
                          name={`studentEngagements[${index}].endYear`}
                          className="form-control"
                          placeholder="Ex: 2017"
                          required
                        />
                        <ErrorMessage
                          name={`studentEngagements[${index}].endYear`}
                          component="div"
                          className="text-danger"
                        />
                      </td>
                      <td>
                        <Field
                          type="text"
                          name={`studentEngagements[${index}].designation`}
                          className="form-control"
                          placeholder="Ex: Head Prefect"
                          required
                        />
                        <ErrorMessage
                          name={`studentEngagements[${index}].designation`}
                          component="div"
                          className="text-danger"
                        />
                      </td>
                      <td className="d-flex justify-content-center align-items-center">
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => remove(index)}
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <button
                type="button"
                className="btn btn-secondary mb-3"
                onClick={() =>
                  push({ startYear: "", endYear: "", designation: "" })
                }
              >
                Add Another
              </button>
            </>
          );
        }}
      </FieldArray>
    </div>
  );
}
